import {FC, ReactNode, useState} from 'react'

import {ResourceSubmenuItem} from '@/content/header'
import {theme} from '@/theme/theme'
import {TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

import {HelpCenterButton} from '../help-center/HelpCenterButton'
import {Header} from './Header'
import {HeaderAuthAction} from './HeaderAuthAction'
import {HeaderMainButton, HeaderMainButtonProps} from './HeaderMainButton'
import {HeaderNavigation} from './HeaderNavigation'
import {HeaderNavigationLabel} from './HeaderNavigationLabel'
import {HeaderLogoResponsive} from './logo/HeaderLogoResponsive'
import {MainHeaderMobileNavigation} from './MainHeaderMobileNavigation'
import {RegionalSettings} from './regional-settings/RegionalSettings'

type MainHeaderProps = {
  hasGetHelpButton: boolean
  hasRegionalSettings: boolean
  navigationLabel?: string
  navigationBadge?: ReactNode
  hasLogin?: boolean
  resourcesSubmenuItems?: ResourceSubmenuItem[]
  mainCtaButton?: HeaderMainButtonProps
}

export const MainHeader: FC<MainHeaderProps> = ({
  hasGetHelpButton,
  hasRegionalSettings,
  navigationLabel,
  navigationBadge,
  hasLogin,
  resourcesSubmenuItems,
  mainCtaButton,
}) => {
  const [isMobileNavigationActive, setMobileNavigationActive] = useState(false)

  return (
    <>
      <Header
        isOverlayVisible={isMobileNavigationActive}
        onOverlayClose={() => setMobileNavigationActive(false)}
      >
        <div className="wrapper content">
          <div className="wrapper navigation">
            <HeaderLogoResponsive mainCtaButton={mainCtaButton} />
            {navigationLabel ? (
              <HeaderNavigationLabel label={navigationLabel} badge={navigationBadge} />
            ) : (
              <div className="desktop">
                <HeaderNavigation resourcesSubmenuItems={resourcesSubmenuItems} />
              </div>
            )}
          </div>
          <div className="wrapper buttons">
            {(hasRegionalSettings || hasGetHelpButton) && (
              <div className="wrapper desktop-buttons">
                {hasRegionalSettings && <RegionalSettings hasLanguageSuggestion />}
                {hasGetHelpButton && <HelpCenterButton />}
              </div>
            )}
            {hasLogin && <HeaderAuthAction />}
            {mainCtaButton && (
              <div className="desktop">
                <HeaderMainButton {...mainCtaButton} />
              </div>
            )}
            {!navigationLabel && (
              <MainHeaderMobileNavigation
                isActive={isMobileNavigationActive}
                setIsActive={setMobileNavigationActive}
                resourcesSubmenuItems={resourcesSubmenuItems}
                hasRegionalSettings={hasRegionalSettings}
                hasGetHelpButton={hasGetHelpButton}
              />
            )}
          </div>
        </div>
      </Header>

      <style jsx>{`
        .content {
          justify-content: space-between;
          width: 100%;
        }
        .wrapper {
          display: flex;
          align-items: center;
          ${!navigationLabel ? `gap: ${theme.spacing[2]}` : ''};
        }
        .navigation {
          ${!navigationLabel ? `gap: ${theme.spacing[4.5]}` : ''};
        }
        .desktop-buttons {
          gap: 0;
        }
        .buttons {
          gap: ${theme.spacing[2]};
        }
        @media ${TABLET_SCREENSIZE} {
          .desktop,
          .desktop-buttons {
            display: none;
          }
          .wrapper:not(.buttons) {
            ${!navigationLabel ? `gap: ${theme.spacing[2]}` : ''};
          }
          .navigation {
            overflow: hidden;
            padding-left: ${theme.spacing[3.5]};
          }
          .buttons {
            padding: ${theme.spacing[3.5]};
            padding-left: 0;
          }
        }
      `}</style>
    </>
  )
}
